var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n            Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n            Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("General Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.generalInfoData) ? _c('div', {
    staticClass: "box"
  }, [_c('View-Details-Component', {
    attrs: {
      "data": _vm.generalInfoData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.generalInfoData == null) ? _c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("No Record Available.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Client SPOC Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.spocInfoData) ? _c('div', {
    staticClass: "box"
  }, [_c('View-Details-Component', {
    attrs: {
      "data": _vm.spocInfoData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.spocInfoData == null) ? _c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("No Record Available.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("XB SPOC Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.bdlist) ? _c('div', {
    staticClass: "box"
  }, [_c('View-Details-Component', {
    attrs: {
      "data": _vm.bdlist
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bdlist == null) ? _c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("No Record Available.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Legal Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.legalInfoData) ? _c('div', {
    staticClass: "box"
  }, [_c('View-Details-Component', {
    attrs: {
      "data": _vm.legalInfoData
    },
    on: {
      "eventFromViewDetails": _vm.eventFromViewDetails
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.legalInfoData == null) ? _c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("No Record Available.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("Bank Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.bankInfoData) ? _c('div', {
    staticClass: "box"
  }, [_c('View-Details-Component', {
    attrs: {
      "data": _vm.bankInfoData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bankInfoData == null) ? _c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("No Record Available.")]) : _vm._e()])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8919ee0c","hasScoped":true}!./src/modules/clientmanagement/views/client/clientlisting/clienteview/clientKYC/clientKYC.component.html
// module id = 701
// module chunks = 3